import type { ThemeOptions } from "@mui/material/styles";

/**
 * Inter is self-hosted through @fontsource-variable so the app no longer
 * blocks first paint on two Google Fonts stylesheets.
 */
export const fontFamily = [
  '"Inter Variable"',
  "Inter",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
].join(",");

export const monoFontFamily = [
  "ui-monospace",
  "SFMono-Regular",
  "Menlo",
  "Monaco",
  "Consolas",
  '"Liberation Mono"',
  "monospace",
].join(",");

export const typography: ThemeOptions["typography"] = {
  fontFamily,
  // The old stylesheet set `html { font-size: 62.5% }`, which redefined rem as
  // 10px and made every declared size a guess. Sizes here are absolute.
  htmlFontSize: 16,
  fontSize: 14,
  h1: { fontSize: "2rem", fontWeight: 700, lineHeight: 1.25, letterSpacing: "-0.02em" },
  h2: { fontSize: "1.625rem", fontWeight: 700, lineHeight: 1.3, letterSpacing: "-0.015em" },
  h3: { fontSize: "1.375rem", fontWeight: 600, lineHeight: 1.35, letterSpacing: "-0.01em" },
  h4: { fontSize: "1.175rem", fontWeight: 600, lineHeight: 1.4 },
  h5: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.45 },
  h6: { fontSize: "0.9375rem", fontWeight: 600, lineHeight: 1.5 },
  subtitle1: { fontSize: "0.9375rem", fontWeight: 500, lineHeight: 1.5 },
  subtitle2: { fontSize: "0.8125rem", fontWeight: 600, lineHeight: 1.5 },
  body1: { fontSize: "0.9375rem", lineHeight: 1.6 },
  body2: { fontSize: "0.875rem", lineHeight: 1.6 },
  button: { fontSize: "0.875rem", fontWeight: 600, textTransform: "none", letterSpacing: 0 },
  caption: { fontSize: "0.75rem", lineHeight: 1.5 },
  overline: {
    fontSize: "0.6875rem",
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  },
};
